import { SIZES as BUTTON_SIZES } from '../Button/Button.constants';
export const SKINS = {
    standard: 'standard',
    inverted: 'inverted',
    light: 'light',
    transparent: 'transparent',
    premium: 'premium',
    dark: 'dark',
    ai: 'ai',
};
export const SIZES = BUTTON_SIZES;
export const PRIORITY = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
};
export const ICON_CHILD_SIZE = {
    [SIZES.tiny]: '18px',
    [SIZES.small]: '18px',
    [SIZES.medium]: '24px',
    [SIZES.large]: '24px',
};
export const testDataHooks = {
    iconOfIconButton: 'iconbutton-icon',
};
//# sourceMappingURL=IconButton.constants.js.map